import { Widget } from "fmko-ts-common";
import { Renderer, RenderingContext } from "fmko-ts-grid";
import CertTestAdminApp from "./CertTestAdminApp";
import { CertTestCaseVO, CertTestVO } from "./RestTypes";

export default class TestCaseRenderer implements Renderer {
    factory: (test: CertTestVO, testCase: CertTestCaseVO) => Widget;

    constructor(factory: (test: CertTestVO, testCase: CertTestCaseVO) => Widget) {
        this.factory = factory;
    }

    public render(ctx: RenderingContext, o: Object) {
        let testCase = <CertTestCaseVO>o;

        let widget = this.factory(CertTestAdminApp.certTestPanel.currentTest, testCase);
        ctx.setWidget(widget);
    }

    public canRender(o: Object): boolean {
        return true;
    }
}
